export type Time = {
  hours: string;
  minutes: string;
  part: TimePartsIndex;
};

export enum TimePartsIndex {
  AM = '0',
  PM = '1',
}
